export const INITIALIZE_STATE = 'INITIALIZE_STATE'

export const SET_AUTHENTICATED = 'SET_AUTHENTICATED'

export const SET_AUTHENTICATED_USER = 'SET_AUTHENTICATED_USER'

export const SET_SELECTED_COMPANY = 'SET_SELECTED_COMPANY'

export const SET_SELECTED_ORDER_OF_SERVICE = 'SET_SELECTED_ORDER_OF_SERVICE'

export const SET_SELECTED_CONTROL_PANEL = 'SET_SELECTED_CONTROL_PANEL'

export const SET_SELECTED_STANDARD = 'SET_SELECTED_STANDARD'
